query TagTypeShow($id: ID!) {
  tagType(id: $id) {
    id
    title
    featured
    seoDescription
    defaultPreviewType
    customFields {
      type
      name
      label
      required
      multiple
      placeholder
      helperText
      options {
        value
        label
      }
    }
    createdAt
    updatedAt
  }
}
